import React, { useEffect, useState } from "react";
import { Row, Col, Spin, Card, Typography, Modal } from "antd";
import {
  LoadingOutlined,
  PrinterFilled,
  EditFilled,
  EyeFilled,
  DeleteFilled,
  PlusCircleOutlined,
} from "@ant-design/icons";

import { Link } from "react-router-dom";

import IntlMessages from "../../../util/IntlMessages";
import TableComponent from "../../../components/Table/TableComponent";

import ButtonComponent from "../../../components/Button/ButtonComponent";
import PackageHeader from "../../Admin/Package/PackageHeader";
import { APP_ROUTES } from "../../../constants/Routes";
import { useDispatch, useSelector } from "react-redux";
import {
  defaultRoomBooking,
  getAvailableRoomsListInProgress,
} from "../../../appRedux/Ward/WardAction";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const AvailableRoomListTable = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [Loading, setLoading] = useState(false);
  const [filteredUsers, setFilteredUsers] = useState("");
  const roomBookedData = useSelector((state) => state?.ward?.roomBook);
  const availableRoomListData = useSelector(
    (state) => state?.ward?.availableRoomsList
  );

  const availableRoomList = availableRoomListData?.data?.data;
  const totalRecords = availableRoomListData?.data?.data?.totalRecords;
  const bookedRoomData = useSelector((state) => state?.ward?.roomBook);
  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Block Name",
      dataIndex: ["Block", "block_name"],
      key: "block_name",
    },
    {
      title: "Ward Name",
      dataIndex: ["Ward", "ward_name"],
      key: "ward_name",
    },

    {
      title: "Room Number",
      dataIndex: "room_no",
      key: "room_no",
    },
    {
      title: "Room Incharge Name",
      dataIndex: "room_incharge_name",
      key: "room_incharge_name",
    },
    {
      title: "Room Type",
      dataIndex: "room_type",
      key: "room_type",
      render: (text, record) => {
        return record.room_type === "1" ? "AC ROOM" : "NON AC ROOM";
      },
    },
    {
      title: "Room Status",
      dataIndex: "room_status",
      key: "room_status",
      render: (text, record) => {
        return record.room_status === "1" ? "Active" : "Inactive";
      },
    },
    {
      title: "Room Price",
      dataIndex: "room_type",
      key: "room_type",
      render: (text, record) => {
        return record.room_type === "1"
          ? record.ac_room_price
          : record.non_ac_room_price;
      },
    },
    {
      title: "Action",
      dataIndex: "Action",
      render: (_, record) => {
        console.log("record", record);
        return (
          <Row className="table-button">
            <Col className="button-edit">
              <Link
                to={{
                  pathname: `/book-room`,
                  state: { room: record },
                }}
              >
                <ButtonComponent
                  type="primary"
                  label={"Book Room"}
                  disabled={record.room_status !== "1"}
                />
              </Link>
            </Col>
          </Row>
        );
      },
    },
  ];
  const handlePage = (page) => {
    const payload = { pagination: "true", pageNo: page, pageSize: "10" };
    dispatch(getAvailableRoomsListInProgress(payload));
  };
  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 72,
      }}
      spin
    />
  );

  const handleSelectChange = (value) => {
    if (value === "all") {
      setFilteredUsers(availableRoomList);
    } else {
      const newData = availableRoomList.slice(0, value);
      setFilteredUsers(newData);
    }
  };

  useEffect(() => {
    if (availableRoomListData?.inProgress) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [availableRoomListData]);
  useEffect(() => {
    const payload = { pagination: "true", pageNo: "1", pageSize: "10" };
    dispatch(getAvailableRoomsListInProgress(payload));
  }, []);
  console.log("filteredUsers", filteredUsers);
  useEffect(() => {
    if (roomBookedData?.success) {
      history.push("/ward-management");
    }
  }, [roomBookedData]);
  useEffect(() => {
    if (bookedRoomData?.success) {
      dispatch(defaultRoomBooking());
    }
  }, [bookedRoomData]);
  return (
    <Card>
      <Row className="p-10 Add-button">
        <Col>
          <Typography className="header-tag">
            {<IntlMessages id={"Addnew.availableRooms"} />}
          </Typography>
        </Col>
        <Col>
          {/* <Link to={APP_ROUTES.ADD_BLOCK}>
            <ButtonComponent
              className="buttons"
              icon={<PlusCircleOutlined />}
              type="primary"
              label={<IntlMessages id={"Addnew.newBlock"} />}
            />
          </Link> */}
        </Col>
      </Row>
      <Spin indicator={antIcon} spinning={Loading}>
        <TableComponent
          columns={columns}
          dataSource={filteredUsers ? filteredUsers : availableRoomList}
          rowselector={handleSelectChange}
          itemList={availableRoomList}
          filteredUsers={filteredUsers}
          setFilteredUsers={setFilteredUsers}
          field={"room_no"}
          documentTitle={"Available Room List"}
        />
      </Spin>
    </Card>
  );
};

export default AvailableRoomListTable;
